import { BrowserRouter } from "react-router-dom";
import { AppRoutes } from "./router";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";
import BackToTop from "./components/feature/BackToTop";

// Backup redirect from .pages.dev to canonical .com domain
if (window.location.hostname === 'oludamolaadebowale.pages.dev') {
  window.location.replace('https://oludamolaadebowale.com' + window.location.pathname + window.location.search + window.location.hash);
}

function App() {
  return (
    <I18nextProvider i18n={i18n}>
      <BrowserRouter basename={__BASE_PATH__}>
        <AppRoutes />
        <BackToTop />
      </BrowserRouter>
    </I18nextProvider>
  );
}

export default App;